import { useEffect } from 'react'
import {
  addCommonFormErrors,
  deleteCommonFormErrors,
} from '@/containers/SubscriptionFormPage/SubscriptionFormConfigurationSlice'
import { useDispatch } from 'react-redux'
import useElectricityMeter from '@/containers/SubscriptionFormPageNew/Components/ElectricityMeter/useElectricityMeter'
import * as Sentry from '@sentry/react'

const useElectricityMeterListener = () => {
  const dispatch = useDispatch()
  const { treatMeterDataInformation, elecMeterUpdate, pdlNo } = useElectricityMeter({ type: 'client' })

  useEffect(() => {
    if (!pdlNo) {
      return
    }
    window.Echo.channel(`pdl.${pdlNo}`).listen('.pdl.response', e => {
      if (e.status === 'pending') {
        elecMeterUpdate({
          pdlEligibilityPending: true,
        })
      }

      if (e.status === 'error') {
        elecMeterUpdate({
          pdlEligibilityPending: false,
          pdlEligibilityLoading: false,
        })
        dispatch(addCommonFormErrors({ meter_id_elec: e.response.exception }))
      }

      if (e.response.elec?.technicalData?.pdl && e.response.elec.technicalData.pdl !== pdlNo) {
        return
      }

      if (e.status === 'success') {
        elecMeterUpdate({
          pdlEligibilityPending: false,
          pdlEligibilityLoading: false,
        })

        dispatch(deleteCommonFormErrors('meter_id_elec'))
        const pdlInformation = e.response

        if (pdlInformation.exception) {
          if (import.meta.env.PROD) {
            Sentry.captureException(new Error('Electricity meter exception'), { extra: { error: pdlInformation.exception } })
          }
          dispatch(addCommonFormErrors({ meter_id_elec: pdlInformation.exception }))
          return
        }
        if (pdlInformation.error && !Array.isArray(pdlInformation.error)) {
          if (
            typeof pdlInformation.error.errors?.authorizations !== 'undefined' &&
            Array.isArray(pdlInformation.error.errors.authorizations)
          ) {
            dispatch(addCommonFormErrors({ meter_id_elec: pdlInformation.error.errors.authorizations[0] }))
            return
          }
          const pdlErrorMsg = typeof pdlInformation.error === 'string' ? pdlInformation.error : pdlInformation.error?.message ?? 'Erreur PDL'
          dispatch(addCommonFormErrors({ meter_id_elec: pdlErrorMsg }))
          return
        }
        treatMeterDataInformation(pdlInformation)
      }
    })
    return () => {
      window.Echo.leaveChannel(`pdl.${pdlNo}`)
    }
  }, [pdlNo])
}

export default useElectricityMeterListener
